import React from 'react';
import { styled } from '@mui/material';
import { Colors } from '../../theme';

interface SelectableCardProps {
    selected?: boolean;
    faded?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export default function SelectableCard({ selected = false, faded = false, onClick, children, style }: SelectableCardProps) {
    return (
        <Card type="button" selected={selected} faded={faded} onClick={onClick} style={style}>
            {children}
        </Card>
    );
}

const Card = styled('button', {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'faded',
})<{ selected: boolean; faded: boolean }>(({ selected, faded }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 8,
    padding: '24px 16px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    borderRadius: 12,
    border: `2px solid ${selected ? Colors.turquoise : Colors.lightGrey}`,
    backgroundColor: selected ? Colors.lightTurq : Colors.white,
    opacity: faded ? 0.5 : 1,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: selected ? `0 0 0 1px ${Colors.turquoise}` : '0 1px 3px rgba(0,0,0,0.06)',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    outline: 'none',
    '&:focus, &:focus-visible': {
        outline: 'none',
    },
    '&:hover': {
        opacity: 1,
        borderColor: Colors.turquoise,
        backgroundColor: selected ? Colors.lightTurq : Colors.lightGrey,
    },
}));
